<template>
  <v-card>
    <v-card-title class="mb-0 pb-1">
      Initial debt payment information
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-simple-table
        min-height="160px"
        class="mt-4"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th
                id="amount"
                class="text-left"
              >
                Initial Debt
              </th>
              <th
                id="amount"
                class="text-left"
              >
                Amount Paid
              </th>
              <th
                id="amount"
                class="text-left"
              >
                Amount Deducted
              </th>
              <th
                id="balance"
                class="text-left"
              >
                Balance
              </th>
              <th
                id="balance"
                class="text-left"
              >
                Date Paid
              </th>
            </tr>
          </thead>
          <thead v-show="isLoading">
            <tr>
              <td colspan="3">
                <v-progress-linear
                  indeterminate
                  class="mt-2"
                  rounded
                ></v-progress-linear>
                <p class="text-center mt-1">
                  Loading...Please wait
                </p>
              </td>
            </tr>
          </thead>
          <tbody v-if="payments.length > 0">
            <tr
              v-for="payment in payments"
              :key="payment.id"
            >
              <td>Ksh {{ payment.initial_unaccounted_debt | formatCurrency }}</td>
              <td>Ksh {{ payment.amount_paid | formatCurrency }}</td>
              <td>Ksh {{ payment.amount_deducted | formatCurrency }}</td>
              <td>Ksh {{ payment.amount_remaining | formatCurrency }}</td>
              <td>{{ payment.created_at | formatDate }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-show="!isLoading">
              <td
                colspan="5"
                style="text-align: center"
              >
                No initial debts found
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  props: {
    payments: {
      type: Array,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style>

</style>
